import { Events } from './events';

function hideFloatingButton() {
  window.dispatchEvent(Events.HideButton());
}

function showFloatingButton() {
  window.dispatchEvent(Events.ShowButton());
}

export default {
  hideFloatingButton,
  showFloatingButton,
};
